// Brand Colors
export const COLORS = {
  primary: '#ac1640',
  primaryHover: '#8b1235',
  secondary: '#232528',
  pink: '#ec4899',
  pinkDark: '#be185d',
  white: '#ffffff',
  gray: {
    50: '#f9fafb',
    100: '#f3f4f6',
    200: '#e5e7eb',
    300: '#d1d5db',
    400: '#9ca3af',
    500: '#6b7280',
    600: '#4b5563',
    700: '#374151',
    800: '#1f2937',
    900: '#111827'
  }
};

// Navigation Items
export const NAVIGATION_ITEMS = [
  { path: '/', label: 'Home' },
  { path: '/data-consultancy', label: 'Data Consultancy' },
  {
    path: '/product',
    label: 'Services',
    children: [
      { path: '/customer-insight-and-propensity/', label: 'Customer Insight & Propensity' },
      { path: '/customer-acquisition/', label: 'Customer Acquisition' },
      { path: '/data-quality-enhancement/', label: 'Data Quality and Enhancement' },
      { path: '/resident-email/', label: 'Email' },
      { path: '/resident-postal/', label: 'Postal Data' },
      { path: '/resident-landline/', label: 'Telephone Data' },
      { path: '/resident-mobile/', label: 'Mobile Data' },
      { path: '/time2call/', label: 'Time2Call' },
      { path: '/goneaway-suppression/', label: 'Goneaway Suppression' },
      { path: '/deceased-suppression/', label: 'Deceased Suppression' }
    ]
  },
  { path: '/evidence', label: 'Evidence' },
  { path: '/news', label: 'News' },
  // { path: '/careers', label: 'Careers' }
];

// Company Information
export const COMPANY_INFO = {
  name: 'Lloyd James Data Consultancy',
  phone: '0800 288 9949',
  logo: '/logos/lloyd-james-data-consultancy-white-logo-color-DC.svg'
};

// Common Styles
export const COMMON_STYLES = {
  container: 'container mx-auto px-4',
  button: {
    primary: 'bg-pink-700 hover:bg-pink-900 text-white font-semibold py-3 px-8 rounded-full transition-colors duration-300',
    secondary: 'bg-white text-gray-900 px-6 py-2 rounded-full font-semibold hover:bg-gray-100 transition-colors'
  },
  section: 'py-16 px-4',
  heading: {
    h1: 'text-4xl md:text-5xl lg:text-7xl font-bold',
    h2: 'text-4xl md:text-5xl font-bold',
    h3: 'text-xl font-bold'
  }
};
